<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="110px">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="所属车场" prop="spaceId">
              <el-select
                v-model="form.spaceId"
                disabled
                style="width:100%"
                placeholder="请选择所属车场"
              >
                <el-option
                  v-for="item in spaceIdList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="所属区域" prop="regionId">
              <el-select v-model="form.regionId" style="width:100%" placeholder="请选择所属区域">
                <el-option
                  v-for="item in regionList"
                  :key="item.id"
                  :label="item.spaceName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车位编号" prop="name">
              <el-input
                clearable
                v-model="form.name"
                placeholder="请输入车位编号"
                maxlength="30"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车位面积" prop="area">
              <el-input
                clearable
                v-model="form.area"
                placeholder="请输入车位面积"
                maxlength="30"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="子母车位" prop="isDouble">
              <el-select
                @change="isDoubleChange"
                v-model="form.isDouble"
                style="width:100%"
                placeholder="请选择子母车位"
                clearable
              >
                <el-option
                  v-for="item in isDoubleData"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车位性质" prop="parkingSpaceNature">
              <el-select
                v-model="form.parkingSpaceNature"
                style="width:100%"
                placeholder="请选择车位性质"
                clearable
              >
                <el-option
                  v-for="item in parkingSpaceNatureDict"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车位状态" prop="spaceStatus">
              <el-select
                v-model="form.spaceStatus"
                style="width:100%"
                placeholder="请选择车位状态"
                @change="spaceStatusChange"
                clearable
              >
                <el-option
                  v-for="item in spaceStatusData"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.spaceStatus == 2 || form.spaceStatus == 3">
            <el-form-item label="业主姓名" prop="personName">
              <el-input
                clearable
                v-model="form.personName"
                placeholder="请输入业主姓名"
                maxlength="30"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.spaceStatus == 2 || form.spaceStatus == 3">
            <el-form-item label="业主电话" prop="personPhone">
              <el-input
                clearable
                v-model="form.personPhone"
                placeholder="请输入业主电话"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.spaceStatus == 2 || form.spaceStatus == 3">
            <el-form-item label="身份证号" prop="certNo">
              <el-input
                clearable
                v-model="form.certNo"
                placeholder="请输入身份证号"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.spaceStatus == 2 || form.spaceStatus == 3">
            <el-form-item label="楼栋/单元" prop="buildingId">
              <el-select
                clearable
                :disabled="model == 'view'"
                @change="buildingChange"
                v-model="form.buildingId"
                style="width:100%"
                placeholder="请选择楼栋/单元"
              >
                <el-option
                  v-for="item in buildingList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.spaceStatus == 2 || form.spaceStatus == 3">
            <el-form-item label="房间名称" prop="roomId">
              <el-select
                clearable
                :disabled="model == 'view'"
                v-model="form.roomId"
                style="width:100%"
                placeholder="请选择房间名称"
                @change="roomIdChange"
              >
                <el-option
                  v-for="item in roomList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.spaceStatus == 2 || form.spaceStatus == 3">
            <el-form-item label="收费套餐" prop="feeRuleId">
              <el-select
                :disabled="model == 'view'"
                v-model="form.feeRuleId"
                style="width:100%"
                placeholder="请选择收费套餐"
                @change="feeRuleIdChange"
              >
                <el-option
                  v-for="item in carRuleList"
                  :key="item.id"
                  :label="item.setmealName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="form.spaceStatus == 2">
            <el-form-item label="是否周期收费" prop="cycleFlag">
              <el-select
                v-model="form.cycleFlag"
                style="width: 100%"
                @change="changeCycleFlag"
               placeholder="请选择是否周期收费"
              >
                <el-option
                  style="padding-left: 10px"
                  v-for="item in cycleFlagDictData"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"

                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="form.spaceStatus == 2">
            <el-form-item label="收费周期数" prop="feeCycleNum">
              <el-input :disabled="form.cycleFlag==0" placeholder="请输入收费周期数" v-model.number="form.feeCycleNum" maxlength="2" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="form.spaceStatus == 2">
            <el-form-item label="收费周期" prop="feeCycleType">
              <el-select
                v-model="form.feeCycleType"
                :disabled="form.cycleFlag==0"
                placeholder="请选择收费周期"
                style="width: 100%"
              >
                <el-option
                  style="padding-left: 10px"
                  v-for="item in feeCycleList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.spaceStatus == 2">
            <el-form-item label="出售日期" prop="soldDay">
              <el-date-picker
                v-model="form.soldDay"
                type="date"
                value-format="yyyy-MM-dd 00:00:00"
                placeholder="请选择出售日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.spaceStatus == 2 || form.spaceStatus == 3">
            <el-form-item label="生效日期" prop="effectTime">
              <el-date-picker
                style="width:100%"
                v-model="form.effectTime"
                type="date"
                value-format="yyyy-MM-dd 00:00:00"
                placeholder="请选择生效日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="description">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入备注"
                v-model="form.description"
                :disabled="model == 'view'"
                maxlength="200"
                show-word-limit
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="    text-align: right;" v-if="model != 'view'">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        提交
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small">
        取消
      </el-button>
    </div>
  </div>
</template>
<script>
import {
  getParkList,
  getRegionList,
  getCarRuleList,
  getBuildingList,
  getRoomList,
  spaceSave,
} from './index.js';
export default {
  components: {},
  props: {
    row: {
      default: {},
    },
    spaceId: {},
    model: {},
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value != '') {
        let reg = /^([0-9]|[1-9][0-9]{0,3})(\.[1-9]|\.[0-9]{1,2})?$/;
        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error('请输入小数点前4位后2位小数的面积'));
        }
      } else {
        callback();
      }
    };
    var validateFeeCycleNum = (rule, value, callback) => {
     console.log(rule)
     let reg = /^([1-9][0-9]*)$/;
     if(rule.required==true){

        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error('周期数必须为大于1的数字值'));
        }
     }else{
      if(value==''){
        callback();
      }else{
        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error('周期数必须为大于1的数字值'));
        }
      }
     }


    };
    return {
      cycleFlagDictData: [
        { label: '是', value: 1 },
        { label: '否', value: 0 },
      ],
      spaceStatusData: [
        {
          dictKey: '1',
          dictValue: '空闲',
        },
        {
          dictKey: '2',
          dictValue: '已出售',
        },
        {
          dictKey: '3',
          dictValue: '已出租',
        },
      ],
      feeCycleList: [
        {
          dictKey: 3,
          dictValue: '月',
        },
        {
          dictKey: 4,
          dictValue: '季',
        },
        {
          dictKey: 5,
          dictValue: '年',
        },
      ],
      isDoubleData: [
        {
          dictKey: '0',
          dictValue: '否',
        },
        {
          dictKey: '1',
          dictValue: '是',
        },
      ],
      parkingSpaceNatureDict:[
        {
          dictKey: 1,
          dictValue:'车位',
        },
        {
          dictKey: 2,
          dictValue:'车库',
        },
      ],
      regionList: [],

      form: {
        spaceId: '',
        regionId: '',
        name: '',
        spaceStatus: '',
        isDouble: '',
        parkingSpaceNature: '',
        area: '',
        personName: '',
        personPhone: '',
        roomId: '',
        buildingId: '',
        roomName: '',
        feeRuleId: '',
        certNo: '',
        soldDay: '',
        effectTime:"",
        description: '',
        cycleFlag:'',
        feeCycleNum:'',
        feeCycleType:''
      },

      formRules: {
        cycleFlag: [{ required: true, message: '是否周期收费不能为空', trigger: 'change' }],
        feeCycleNum: [{ required: true,validator: validateFeeCycleNum, trigger: 'blur' },

      ],
        feeCycleType: [{ required: true, message: '收费周期不能为空', trigger: 'change' }],
        area: [{ required: false, validator: validatePass, trigger: 'blur' }],
        spaceId: [{ required: true, message: '所属车场不能为空', trigger: 'blur' }],
        regionId: [{ required: true, message: '所属区域不能为空', trigger: 'change' }],
        name: [{ required: true, message: '车位编号不能为空', trigger: 'change' }],
        spaceStatus: [{ required: true, message: '车位状态不能为空', trigger: 'change' }],
        isDouble: [{ required: true, message: '子母车位不能为空', trigger: 'change' }],
        parkingSpaceNature: [{ required: true, message: '车位性质不能为空', trigger: 'change' }],
        personName: [{ required: true, message: '业主姓名不能为空', trigger: 'change' }],
        personPhone: [{ required: true, message: '业主电话不能为空', trigger: 'change' }],
        roomId: [{ required: false, message: '房间名称不能为空', trigger: 'change' }],
        buildingId: [{ required: false, message: '楼栋/单元不能为空', trigger: 'change' }],
        feeRuleId: [{ required: true, message: '收费套餐不能为空', trigger: 'change' }],
        soldDay: [{ required: true, message: '出售日期不能为空', trigger: 'change' }],
        effectTime: [{ required: true, message: '生效日期不能为空', trigger: 'change' }],
      },
      tableHeight: '',
      spaceIdList: [],
      carRuleList: [],
      buildingList: [],
      roomList: [],
      carRuleDiscountList: [],
    };
  },
  created() {
    this.initData();
  },
  mounted() {},

  methods: {
    spaceStatusChange(val) {
      this.form.feeCycleNum = '';
        this.form.feeCycleType ='';
        this.form.cycleFlag=''
        this.formRules.feeCycleNum[0].required=true
        this.formRules.feeCycleType[0].required=true
        this.$nextTick(()=>{
        this.$refs['formRef'].clearValidate("feeCycleNum")
        this.$refs['formRef'].clearValidate("feeCycleType")
       })

    },
    changeCycleFlag(val) {
      if(val==0){
        this.form.feeCycleNum = '';
        this.form.feeCycleType ='';
        this.formRules.feeCycleNum[0].required=false
        this.formRules.feeCycleType[0].required=false
      }else{
        this.formRules.feeCycleNum[0].required=true
        this.formRules.feeCycleType[0].required=true
      }
      this.$nextTick(()=>{
        this.$refs['formRef'].clearValidate("feeCycleNum")
        this.$refs['formRef'].clearValidate("feeCycleType")
       })
    },
    //子母车位改变清空规则相关
    isDoubleChange() {
      this.form.feeRuleId = '';
      this.carRuleList = [];
      this.getCarRuleList();
    },
    //房间选择后要保存名字传给后端
    roomIdChange(val) {
      this.roomList.forEach((item) => {
        if (item.value == val) {
          this.form.roomName = item.label;
        }
      });
    },
    buildingChange() {
      this.roomList = [];
      this.form.roomId = '';
      this.getRoomList();
    },

    initData() {
      getParkList().then((res) => {
        this.spaceIdList = res.data;
      });

      this.form.spaceId = this.spaceId;
      //获取区域
      getRegionList({
        spaceId: this.form.spaceId,
      }).then((res) => {
        this.regionList = res.data;
      });

      this.getBuildingList();
      this.getRoomList();
    },

    getCarRuleList() {
      getCarRuleList({
        spaceId: this.form.spaceId,
        packageType: 2,
        isDouble: this.form.isDouble,
      }).then((res) => {
        this.carRuleList = res.data;
      });
    },
    getBuildingList() {
      getBuildingList({ spaceId: this.form.spaceId }).then((res) => {
        this.buildingList = res.data;
      });
    },

    getRoomList() {
      getRoomList({ buildingId: this.form.buildingId }).then((res) => {
        this.roomList = res.data;
      });
    },
    saveRecord() {
      this.$refs['formRef'].validate((valid) => {
        if (valid) {
          spaceSave(this.form).then((res) => {
            this.$message.success('新增成功');
            this.$emit('success');
          });
        } else {
        }
      });
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
<style scoped>
::v-deep .el-col-12 {
  height: 54px;
}
</style>
